/**
 * Marketing referral capture.
 *
 * Use case: poster QR codes / ad links point at `bosunsmate.app/?ref=marina`.
 * We persist the ref the first time a visitor lands, then attach it to the
 * user's record after they sign up — so we can later tally signups per
 * marketing channel.
 *
 * Storage: localStorage, 30-day TTL, single value (most recent wins).
 * Only persisted on web — native apps never see a marketing URL.
 */

const KEY = "bm_signup_ref";
const TTL_DAYS = 30;
const VALID = /^[a-z0-9_-]{1,32}$/i;  // tight allowlist — no XSS risk

export function captureRefFromUrl() {
    if (typeof window === "undefined") return;
    try {
        const params = new URLSearchParams(window.location.search);
        const ref = (params.get("ref") || "").trim();
        if (!ref || !VALID.test(ref)) return;
        const payload = { ref, ts: Date.now() };
        localStorage.setItem(KEY, JSON.stringify(payload));
    } catch (e) {
        // localStorage may be unavailable in private-browse / disabled storage
        console.warn("[ref] capture failed", e);
    }
}

export function getStoredRef() {
    if (typeof window === "undefined") return null;
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return null;
        const { ref, ts } = JSON.parse(raw);
        if (!ref || !VALID.test(ref)) return null;
        const ageDays = (Date.now() - (ts || 0)) / 86400000;
        if (ageDays > TTL_DAYS) {
            localStorage.removeItem(KEY);
            return null;
        }
        return ref;
    } catch {
        return null;
    }
}

export function clearStoredRef() {
    if (typeof window === "undefined") return;
    try {
        localStorage.removeItem(KEY);
    } catch {
        /* ignore */
    }
}
